import React, { Fragment, useMemo, useState } from 'react';
import AppTable from '../../../../constants/AppTable';
import { Product } from '../../../../helpers/models/Models';
import { LoadingSpinner } from '../../../../constants/AppLoading';
import ProductEditView from './dialog/ProductEditView';

interface ProductListViewProps {
    results: {
        results: Product[];
        previous: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
    setOnURL: React.Dispatch<React.SetStateAction<string>>;
    handleFormSuccess: () => void;
}
const ProductListView: React.FC<ProductListViewProps> = ({ results, loading, error, handleFormSuccess, setOnURL }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState<Product | null>(null);

    const columns = [
        { header: 'SN', accessor: 'sn', sortable: false },
        { header: 'Product Category', accessor: 'sub_master_name', sortable: true },
        { header: 'Product Name', accessor: 'pro_name', sortable: true },
        { header: 'Pro. Name(Nepali)', accessor: 'pro_name_nep', sortable: false },
        { header: 'Purchase Rate', accessor: 'pur_rate', sortable: false },
        { header: 'Sales Rate', accessor: 'sales_rate', sortable: false },
        { header: 'Purchase Unit', accessor: 'purchase_unit_name', sortable: false },
        { header: 'Sales Unit.', accessor: 'sales_unit_name', sortable: false },
        { header: 'Stock Limit QTY', accessor: 'stock_limit_qty', sortable: false },
        { header: 'Model No.', accessor: 'model_no', sortable: false },
        { header: 'Opening Stock', accessor: 'opening_stock', sortable: false },
        { header: 'Start Date', accessor: 'start_date', sortable: false },
        { header: 'With VAT', accessor: 'with_vat', sortable: false },
        { header: 'Discount', accessor: 'discable', sortable: false },
        { header: 'Discount Percentage', accessor: 'disc_perc', sortable: false },
        { header: 'Discount Amount', accessor: 'disc_amt', sortable: false },
        { header: 'Char Code', accessor: 'char_code', sortable: false },
        { header: 'Sizes', accessor: 'sizes', sortable: false },
        { header: 'Actions', accessor: 'actions', action: true },
    ];
    const modifiedData = useMemo(() => {
        if (!results) return [];
        return results.results.map((item: Product) => ({
            sn: item.sn,
            sub_master_name: item.sub_master_name || 'N/A',
            pro_name: item.pro_name,
            pro_name_nep: item.pro_name_nep || 'N/A',
            pur_rate: item.pur_rate,
            sales_rate: item.sales_rate,
            purchase_unit_name: item.purchase_unit_name || 'N/A',
            sales_unit_name: item.sales_unit_name || 'N/A',
            stock_limit_qty: item.stock_limit_qty,
            model_no: item.model_no || 'N/A',
            opening_stock: item.opening_stock,
            start_date: item.start_date,
            with_vat: item.with_vat ===1?"Yes":"No", // Keep numeric value
            discable: item.discable ===1?"Yes":"No", // Keep numeric value
            disc_perc: item.disc_perc,
            disc_amt: item.disc_amt,
            char_code: item.char_code || 'N/A',
            sizes: item.sizes || 0,
            sub_master: item.sub_master,
            purchase_unit: item.purchase_unit,
            sales_unit: item.sales_unit,
            status: item.status,
            active:item.status,
            product_master: item.product_master,
            vat_perc: item.vat_perc,

        }));
    }, [results]);
    
    const handleEdit = (item: Product | null) => {
        setCurrentItem(item); 
        setDialogOpen(true);
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (error) {
        return <p>Error loading data: {error}</p>;
    }

    return (
        <Fragment>
            <AppTable
                columns={columns}
                data={modifiedData}
                onNext={() => results?.next && setOnURL(results.next)}
                onEdit={handleEdit}
                onPrev={() => results?.previous && setOnURL(results.previous)}
            />
            <ProductEditView handleFormSuccess={handleFormSuccess} currentItem={currentItem} setDialogOpen={setDialogOpen} dialogOpen={dialogOpen} />
        </Fragment>
    )
}

export default ProductListView